import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const operationBenefitsService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/OperationBenefits`, { headers });
  },

  getById: async (id) => {
    return await axios.get(`${domain}/api/OperationBenefits/${id}`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/OperationBenefits`, payload, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/OperationBenefits/${id}`, payload, { headers });
  },
};

export default operationBenefitsService;